export default {
  main_wrapper: 'flex flex-wrap md:pb-10',
  sectionContainer: 'w-1/3 mt-8',
  divider: 'h-px bg-grey m-2',
  sub_main_wrapper: 'bg-grey-lighter',
  sub_main_wrapperdiv: 'pt-10',
  readAnchor: 'bg-black',
  accordHeading: 'accordion-header',
  carasousal: {
    carousalWrapper: 'carousel-caption',
    carousalText: ' header text-white ',
    carousalButton: 'mt-8 py-2 px-4 md:block hidden btn btn-solid',
    carouselMain: 'carousel-pane-body',
    rightArrow: 'glyphicon glyphicon-menu-left text-grey-light text-6xl',
    leftArrow: 'glyphicon glyphicon-menu-right text-grey-light text-6xl',
    carouselContainer: 'relative',
    carasousalMedia: 'w-full',
    carasoulGlyphiconLeft: 'glyphicon glyphicon-menu-left',
    carasoulGlyphiconRight: 'glyphicon glyphicon-menu-right',
    carasousalSliderLeftImg: 'md:ml-15',
    carasousalSliderRighttImg: 'md:mr-15',
    carouselImg: 'sm:w-full sm:block md:w-1/2 mt-25 px-15 product-carousel',
    carouselDesc: 'sm:w-full sm:block md:w-1/2 md:px-15 md:mt-25',
  },
  card: {
    main_wrapper: 'max-w-sm rounded overflow-hidden',
    content: 'px-6 py-4',
    media: 'w-full',
    header: 'sm:mt-0 font-sans-roma text-s13-m13-l15 text-black md:mt-8 ',
    description: 'text-13 text-black py-2 my-2 sm:font-sans-roma',

    card_horizontal: 'flex flex-row',
    card_horizontal_wrapper: 'px-15 md:px-0',
    card_horizontal_wrapper_img: 'md:px-15',
    card_horizontal_wrapper_desc: 'px-15 md:px-0',
  },
  pdpdetail: {
    pdp_container:
      'container product-hero device-full-width mb-20 md:mb-0 md:px-15 lg:px-0 md:pb-30 md:leading-33',
    pdp_sec_container: 'container sm:mt-0 sm:px-0 md:px-15 md:mt-35',
    desc_header:
      'inline-block align-top  font-thin text-black mt-px-40 pb-20 text-s20-m30-l36 lg:text-7xl leading-tighter',

    desc_rating:
      'text-nav-text inline-block align-top mb-15 text-13 font-sans-roma',
    desc_review:
      'inline-block font-sans-roma w-1/2 md:w-5/12 lg:w-4/12 text-black text-s13-m13-l15 align-top md:mt-2 md:mb-1 mr-15 md:mr-0 lg:mr-15',
    desc_writeReview:
      'inline-block font-sans-roma text-black text-s13-m13-l15 align-top md:pt-2 md:mr-60 md:pb-1',
    desc_review_count:
      'relative font-sans-roma text-grey-darkest text-13 ml-10 -top-5 cursor-pointer',
    desc_review_recom:
      'relative font-sans-roma text-grey-darkest text-13 -top-5 sm:block sm:ml-0 sm:mt-15 md:inline md:ml-30',
    buy_Button: 'btn btn-secondary',
    desc:
      'inline-block font-sans-roma text-s13-m13-l15 text-black align-top mb-30',
    anchorlink: 'cursor-default event_product_review_view',
    ratingLink: 'cursor-pointer event_product_review_view',
    reviewLink: 'inline-block mr-2 font-bold',
  },
  tab: {
    tabdiv: 'mb-10 ',
    tabdetail:
      'pdp-tab-detail flex flex-wrap font-sans-roma bg-white text-black md:px-15 md:pt-30 md:pb-40',
    tabdetail_maintain: 'tabdet_maintain mx-8 md:mx-0 md:pt-0',
    tabdet_faq: 'text-s18-m20-l24',
    ratingdiv: 'bg-white my-2',
    rating_review: 'pt-10 px-15 pb-20 md:pt-30 md:px-30 md:pl-20',
    rating_review_reviewCount: 'ml-10 relative -top-5',
    rating_review_ratingValue: 'ml-20 relative -top-5',
    default_tabcolor: 'default_Tabcolor text-grey-darkest',
    selected_tabcolor: 'selectedTabcolor bg-white',
    tabtext:
      'inline-flex flex-col justify-content content-center w-full font-sans-bold text-s13-m13-l15 pl-25 pr-25 pt-10 pb-10',
    accordiandiv: 'md:hidden',
    tabLabel: 'overflow-hidden h-10 mt-2',
  },
  Smartphone: {
    description: 'faq-content md:px-15 font-sans-roma text-s13-m13-l15',
    accordion: {
      panel: 'w-full ',
      panelHeader: 'lg:px-15',
      panelDetail: 'trans-500-max-h p-0',
      icon: 'flex justify-center hfe-down-arrow',
      iconCollapse: 'hfe-up-arrow absolute',
      expanded:
        'md:max-h-500 pb-30 overflow-auto border-b lg:px-15 block bg-white accordion-animate open-animate',
      collapsed: 'max-h-0 overflow-hidden p-0 md:block accordion-animate',
      panel_head: 'accordion-head-text py-10 md:hidden smartphone',
      icon_span: 'mt-15',
    },
  },
  Both: {
    description: 'faq-content md:px-15 font-sans-roma text-s13-m13-l15',
    accordion: {
      panel: 'w-full',
      panelHeader: 'px-15 py-0',
      panelDetail: 'trans-500-max-h p-0',
      icon: 'pt-3 top-55 accordian-arrow',
      iconCollapse: 'top-55 accordian-arrow-collapse',
      expanded: 'md:max-h-500 pb-30 overflow-auto px-15 block bg-white',
      collapsed: 'max-h-0 overflow-hidden p-0 sm:hidden md:hidden px-15',
      panel_head:
        'relative font-sans-bold text-white py-3 text-base md:text-lg',
      icon_span: 'mt-15',
    },
  },
  footerNavigation: {
    description: 'faq-content md:px-15 font-sans-roma text-s13-m13-l15',
    accordion: {
      panel:
        ' footer-panel-width footerAccoedianBorder border-b-1 border-lightGrey border-solid px-20 py-15 md:py-0 md:px-0 md:border-0 md:pr-30',
      panelHeader:
        'font-sans-bold text-black bg-white text-s13-m13-l15 accordianMobHeader',
      panelDetail: 'footer-nav-links',
      icon: 'md:pb-5 top-55 footer-accordian-arrow',
      iconCollapse: 'top-55 footer-accordian-arrow-collapse',
      expanded:
        'md:max-h-500 md:pb-0 overflow-auto px-15 md:px-0 block bg-white lg:border-none',
      collapsed: 'overflow-hidden  p-0 sm:hidden md:block ',
      panel_head:
        'font-BebasNeueRegular text-24 font-semibold text-black bg-white tracking-wide footerDtNavLink',
      icon_span: 'mt-15',
    },
  },
  accordian: {
    panelHeader: 'px-15 py-0',
    panel_head:
      'font-BebasNeueRegular text-30 text-black bg-white pt-5 footerDtNavLink',
    panel:
      'w-full mx-auto three-accordion flex flex-col md:flex-row justify-between',
    icon: 'float-right',
    expanded: 'md:max-h-500 overflow-auto pt-10 pb-30',
    panel_header: 'px-15',
    icon_span: 'mt-15',
  },
  pdpSecondoryText: {
    pdpSecText: ' font-sans-roma w-full pb-20 md:pb-0',
    accordionimg: 'font-sans-roma',
    wrapper: 'md:px-15',
  },
  breadcrumb_li: {
    list_item: 'flex-wrap list-ul',
    list_li: 'font-sans-bold text-sm text-black mr-1',
  },
  list_item: 'flex list-ul',
  list_li: 'font-sans-bold text-sm text-black mr-1',

  stackedCard: {
    card: 'sm:text-center border-none',
    spacing: 'sm:pr-0 sm:pl-0',
  },
  accordianTab: {
    richTextWrapper: 'leading-s19-m19-l23 font-sans-roma md:mx-6',
    richText: 'maintenance-text md:pb-30 md:px-15 sm:pt-2 md:pt-0',
  },
  BuyNowDialogStyle: {
    modal: 'country-selector-dialog mx-auto text-left lg:mt-20',
    extraStyle: 'dialog-extra-style',
    buttonStyle: 'no-underline","text-nav-text',
    dialogTitle: 'relative pt-0 pl-0 pb-6 text-4xl font-sans-light',
    closeDialog: 'absolute right-0 headclose',
    closeButton: 'closespan',
    dialogBody: 'w-full flex flex-wrap pb-4 lg:pt-3',
  },
  ohmAccordian: {
    description: '',
    accordion: {
      panel: 'w-full ',
      panelHeader: 'relative accordianBtn text-center',
      panelDetail: 'trans-500-max-h p-0 expandedTxt relative',
      icon: 'float-right pt-3',
      expanded: 'md:max-h-500 pb-30 overflow-auto px-15 block bg-grey-2',
      collapsed: 'max-h-0 overflow-hidden p-0 sm:hidden',
      panel_head: 'ohmAccordian',
      icon_span: 'mt-15 ',
    },
  },
};
